//Add strict mode
'use strict';
import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { connect } from 'react-redux'
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { getThemeProps } from '@mui/system';
import { setLeftSearchVal, setOpenBoothList, setLeftPage } from '../../../actions/ui'
import InputBase from '@mui/material/InputBase';
import EditIcon from '@mui/icons-material/Edit';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import Button from '@mui/material/Button';
import CompanyEditModal from '../CompanyEditModal'
import { useEffect,useState,useRef } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import { setActive3dObject } from '../../../actions/main';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
const ColorButton = styled(Button)(({ theme }) => ({
  color: '#7c7c7c',
  minWidth:'55px',
  width: '38px',
  minWidth: 'unset',
  padding: 0,
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: '#c9c9c980',
  },
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  float: 'right',
  marginTop: 12
}));

function paginate(array, page_size, page_number) {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
}

function descendingComparator(a, b, orderBy) {
  var a_val = (a[orderBy])?a[orderBy]:''
  var b_val = (b[orderBy])?b[orderBy]:''
  if(orderBy == 'date'){
    if(a_val && b_val)
      return new Date(a_val) - new Date(b_val);
    else
       return false
  }
  else{
    return a_val.toString().localeCompare(b_val.toString(), 'en', { numeric: true })
  }
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    // if (order !== 0) {
      return order;
    // }
    // return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

// Display labels for Action column (UI-only; stored action codes unchanged)
var AUDIT_ACTION_LABELS = {
  'move': 'Move',
  'shift': 'Shift',
  'resize': 'Resize',
  'assign': 'Exhibitor Assigned',
  'unassign': 'Exhibitor Unassigned',
  'add': 'Created',
  'delete': 'Deleted',
  'combine': 'Combined',
  'uncombine': 'Uncombine',
  'undelete': 'Booth Restored',
  'rename': 'Renamed',
  'buy': 'Purchased',
  'hold': 'Hold',
  'unhold': 'Unhold/Release',
  'price_assign': 'Pricing Assigned',
  'price_unassign': 'Pricing Unassigned',
  'price_update': 'Pricing Updated',
  'set_background': 'Background Set',
  'delete_background': 'Background Removed',
  'import dwg': 'Map Imported',
  'delete_dwg': 'Map Deleted',
};

var UNDO_PREFIX = /^(Delete|Add|Undelete|Rename|Resize|Shift|Combine|Uncombine) undone:/i;

// ponytail: prefer log.booth_number (new writers); else parse description — ceiling: brittle wording; upgrade = always store booth_number
function getAuditDisplayRow(log) {
  if (!log) {
    return { actionLabel: 'Other', boothNumber: '-', otherDetails: '-' };
  }
  var description = log.description || '';
  var otherDetails = description || '-';
  var boothNumber = '-';
  var actionLabel = 'Other';

  if (UNDO_PREFIX.test(description)) {
    actionLabel = 'Undo';
    // Prefer parent / restored-to over first "booth X" (rename: "booth B restored to A")
    var undoBooth =
      description.match(/parent (\S+)/i) ||
      description.match(/Assigned Booth (\S+)/i) ||
      description.match(/restored to (\S+)/i) ||
      description.match(/booth (\S+)/i);
    if (undoBooth) boothNumber = undoBooth[1].replace(/[,.]$/, '');
    return { actionLabel: actionLabel, boothNumber: boothNumber, otherDetails: otherDetails };
  }

  if (log.action && AUDIT_ACTION_LABELS[log.action]) {
    actionLabel = AUDIT_ACTION_LABELS[log.action];
  }

  if (log.booth_number) {
    boothNumber = String(log.booth_number).trim();
    return { actionLabel: actionLabel, boothNumber: boothNumber, otherDetails: otherDetails };
  }

  var m;
  switch (log.action) {
    case 'move':
      m = description.match(/moved booth: (\S+)/i);
      break;
    case 'shift':
      m = description.match(/moved booth:?\s*([^:\n\s]+)|shifted booth:?\s*([^:\n\s]+)/i);
      break;
    case 'resize':
      m = description.match(/Assigned Booth (\S+)/i);
      break;
    case 'assign':
      m = description.match(/assigned booth (\S+)/i);
      break;
    case 'unassign':
      m = description.match(/from booth (\S+)/i) || description.match(/booth (\S+)/i);
      break;
    case 'add':
      m = description.match(/added (?:custom )?booth: (\S+)/i);
      break;
    case 'delete':
      m = description.match(/deleted booth (\S+)/i);
      break;
    case 'combine':
      m = description.match(/to (\S+)\s*$/i);
      break;
    case 'uncombine':
      m = description.match(/uncombined (\S+) to/i);
      break;
    case 'undelete':
      m = description.match(/undeleted booth (\S+)/i);
      break;
    case 'rename':
      m = description.match(/to (\S+)\s*$/i);
      break;
    case 'buy':
      m = description.match(/^bought (.+)$/i);
      break;
    case 'hold':
    case 'unhold':
      m = description.match(/booth (\S+)/i);
      break;
    case 'price_assign':
    case 'price_unassign':
    case 'price_update':
      m = description.match(/booth (\S+)/i);
      break;
    default:
      m = null;
  }
  if (m && m[1]) boothNumber = m[1].trim();

  return { actionLabel: actionLabel, boothNumber: boothNumber, otherDetails: otherDetails };
}

function auditSearchText(booth) {
  var d = getAuditDisplayRow(booth);
  return (
    (booth.date ? ' ' + booth.date : '') +
    (booth.user ? booth.user : '') +
    d.actionLabel +
    d.boothNumber +
    (booth.description ? booth.description : '')
  );
}

// Split "7/30/2026, 1:23:42 AM" → two lines so Date column can stay narrow
function formatAuditDateParts(dateStr) {
  if (!dateStr) return { dateLine: '', timeLine: '' };
  var s = String(dateStr).trim();
  var comma = s.indexOf(',');
  if (comma === -1) return { dateLine: s, timeLine: '' };
  return { dateLine: s.slice(0, comma).trim(), timeLine: s.slice(comma + 1).trim() };
}

// Self-check: fails in console if parse/label map breaks
;(function checkAuditDisplayRow() {
  var cases = [
    { log: { action: 'move', description: 'moved booth: 3037' }, label: 'Move', booth: '3037' },
    { log: { action: 'combine', description: 'combined 1,2,3 to 99' }, label: 'Combined', booth: '99' },
    { log: { action: 'uncombine', description: 'uncombined 3429 to 3430,3429' }, label: 'Uncombine', booth: '3429' },
    { log: { action: 'undelete', description: 'Delete undone: booth 11 restored' }, label: 'Undo', booth: '11' },
    { log: { action: 'rename', description: 'Rename undone: booth 3038 restored to 3037' }, label: 'Undo', booth: '3037' },
    { log: { action: 'shift', description: 'Shift undone: booth Rt45 restored:\nX axis: 20 to 10\nY axis: 30 to 15', booth_number: 'Rt45' }, label: 'Undo', booth: 'Rt45' },
    { log: { action: 'import dwg', description: 'imported map floor1.dwg' }, label: 'Map Imported', booth: '-' },
    { log: { action: 'add', description: 'added custom booth: 99' }, label: 'Created', booth: '99' },
    { log: { action: 'shift', description: 'Moved booth Rt45:\nX axis: 10 to 20', booth_number: 'Rt45' }, label: 'Shift', booth: 'Rt45' },
    // New actions: prefer booth_number so Other Details can stay AC-style (no booth in text)
    { log: { action: 'unassign', description: 'Unassigned Acme Corp', booth_number: '101' }, label: 'Exhibitor Unassigned', booth: '101' },
    { log: { action: 'hold', description: 'booth 202 put on hold', booth_number: '202' }, label: 'Hold', booth: '202' },
    { log: { action: 'unhold', description: 'booth 204 released from hold', booth_number: '204' }, label: 'Unhold/Release', booth: '204' },
    { log: { action: 'price_assign', description: 'Fee Name: Exhibit Space', booth_number: '301' }, label: 'Pricing Assigned', booth: '301' },
    { log: { action: 'price_unassign', description: 'Removed Fee: Exhibit Space', booth_number: '302' }, label: 'Pricing Unassigned', booth: '302' },
    { log: { action: 'price_update', description: 'Exhibit Space to 10x10 ($31/nsf)', booth_number: '303' }, label: 'Pricing Updated', booth: '303' },
    { log: { action: 'unassign', description: 'Unassigned Acme Corp' }, label: 'Exhibitor Unassigned', booth: '-' },
  ];
  for (var i = 0; i < cases.length; i++) {
    var r = getAuditDisplayRow(cases[i].log);
    if (r.actionLabel !== cases[i].label || r.boothNumber !== cases[i].booth) {
      console.error('[AuditLog] getAuditDisplayRow self-check failed', cases[i], r);
    }
  }
})();

function BoothList(props) {
  const theme = useTheme();
  const [openCompanyModal, setOpenCompanyModal] = React.useState(false);
  const [boothList, setBoothList] = React.useState([]);
  const [loadingFlag, setLoadingFlag] = React.useState(false)
  const [filteredBoothList, setFilteredBoothList] = React.useState([]);
  const [searchVal, setSearchVal] = React.useState(null);
  const [page, setPage] = React.useState(1);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('date');
  const keywordInput = useRef(null);
  
  const [editBooth, setEditBooth]  = React.useState(null);
  const page_size = 15;
  const main_widow_offset_x = 0;
  const main_widow_offset_y = 51;
  const handleChangePage = (event, value) => {
    setPage(value);
  }
  const createSortHandler = (property) => {
    // Date + User only — Action/Booth #/Other Details stay chronological by date
    if (property !== 'date' && property !== 'user') return;
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };



  useEffect(() => {
    if (!props.ui.openBoothList) {
      return;
    }

    setTimeout(function(){
      const allLogs = props.log.logs || [];


      // Base list: only entries that have an action
      const baseList = allLogs.filter((booth) => booth.action);
      setBoothList(baseList);

      // Apply current search term, if any
      if (searchVal) {
        const filtered = baseList.filter((booth) => {
          return auditSearchText(booth).toLowerCase().includes(searchVal.toLowerCase());
        });
        setFilteredBoothList(filtered);
      } else {
        setFilteredBoothList(baseList);
      }

      setLoadingFlag(false);
    }, 300);
  }, [props.ui.openBoothList, props.main.canvasRefresh, props.log.logs, searchVal]);


  const doSearch = (searchVal)=>{
    setSearchVal(searchVal || null);

    // When user types, filter immediately against latest logs
    const allLogs = props.log.logs || [];
    const baseList = allLogs.filter((booth) => booth.action);

    if (searchVal) {
      const filtered = baseList.filter((booth) => {
        return auditSearchText(booth).toLowerCase().includes(searchVal.toLowerCase());
      });
      setFilteredBoothList(filtered);
    } else {
      setFilteredBoothList(baseList);
    }
  }

  const handleDrawerOpen = () => {
    props.setOpenBoothList(true);
  };

  const handleDrawerClose = () => {
    props.setOpenBoothList(false);
  };

  const handleOpenCompanyModal=(index)=>{
    setEditBooth(filteredBoothList[index])
    setOpenCompanyModal(true)
  }

  const handleCloseCompanyModal=(index)=>{
    setOpenCompanyModal(false)
  }

  const setActiveObject = (o) => {
    var mainCanvas = props.main.mainCanvas;
    // mainCanvas.getObjects().forEach(function(o) {
    //   if(o.id == "booth-"+id) {
    //     console.log("selected", o)
        mainCanvas.viewportTransform[0] = 1;
        mainCanvas.viewportTransform[3] = 1;
        mainCanvas.viewportTransform[4] = window.screen.width/2-o.left-o.width/2-main_widow_offset_x;
        mainCanvas.viewportTransform[5] = window.screen.height/2-o.top-o.height/2-main_widow_offset_y;
        window.scrollTo(0, 0)
        mainCanvas.requestRenderAll();
        mainCanvas.setActiveObject(o).renderAll();
        props.setActive3dObject(o)
    //   }      
    // })
  }

  // var boothList=[...props.main.boothList]
  // boothList.sort(function(a, b) {
  //   const nameA = a.boothName; // ignore upper and lowercase
  //   const nameB = b.boothName; // ignore upper and lowercase
  //   if (nameA < nameB) {
  //     return -1;
  //   }
  //   if (nameA > nameB) {
  //     return 1;
  //   }
  
  //   // names must be equal
  //   return 0;
  // });
  // boothList.sort(function(a, b) {
  //   return a.boothName - b.boothName;
  // });

  const renderDescription = (description) => {
    if (!description) return null;
    const resizePattern = /^Assigned Booth (\S+) updated from (.+) to (.+)$/;
    const resizeMatch = description.match(resizePattern);
    if (resizeMatch) {
      const [, boothNumber, oldSize, newSize] = resizeMatch;
      return (
        <>
          Assigned Booth{' '}
          <span style={{ fontWeight: 'bold' }}>{boothNumber}</span>
          {' '}updated from{' '}
          <span style={{ fontWeight: 'bold' }}>{oldSize}</span>
          {' '}to{' '}
          <span style={{ fontWeight: 'bold' }}>{newSize}</span>
        </>
      );
    }
    const mapPattern = /^(imported map|deleted map) (.+)$/;
    const mapMatch = description.match(mapPattern);
    if (mapMatch) {
      const [, prefix, mapName] = mapMatch;
      return (
        <>
          {prefix}{' '}
          <span style={{ fontWeight: 'bold' }}>{mapName}</span>
        </>
      );
    }
    return description;
  };

  const searchBox = ()=>{
    return (
      <Paper
        className='search-bar'
        sx={{ p: '0px 0px', display: 'flex', alignItems: 'center', maxWidth:'370px', margin:'0 auto 10px' }}
      >
        
          <SearchIcon sx={{ p: '5px' }} />
        <InputBase
          sx={{ flex: 1, width:300  }}
          placeholder="Search by keyword"
          inputProps={{ 'aria-label': 'Search by keyword' }}
          // val={keyword}
          onChange={(e)=>doSearch(e.target.value)}
          inputRef={keywordInput}
        />
        {/* <Button onClick={doSearch} className='search-attach' variant="contained" color="primary" sx={{ p: '10px' }} aria-label="directions">
          Search
        </Button> */}
      </Paper>
    )
  }

  
  var sortData = stableSort(filteredBoothList, getComparator(order, orderBy))

  var pageData = paginate(sortData, page_size, page);
  return (
    <Fade in={true} timeout={1200}>
      <div className='appLeftSearch'>
        <Box className="">
        <Box display="flex" style={{alignItems:'center', justifyContent:'space-between'}} pt={2}  pb={2}>
            
                <div style={{marginLeft:20}}></div>
                <Box textAlign="left">
                  <Box display="flex">
                    <h4 style={{textTransform:'capitalize', margin:0}}>
                    Audit log
                    </h4> 
                    <span style={{color:'#a0a0a0',  marginLeft:5}}>({filteredBoothList?filteredBoothList.length:0})</span>
                  </Box>
                </Box>
                <div style={{display:'flex', alignItems:'center', paddingRight:3}}>
                  {props.role == 'admin' ?          
                  <IconButton
                      size="small"
                      edge="start"
                      aria-label="assign"
                      style={{float:'right'}}
                      onClick={()=>{props.setOpenBoothList(false)}}
                    >
                      <HighlightOffOutlinedIcon/>
                  </IconButton>:
                  <IconButton
                    size="small"
                    edge="start"
                    aria-label="assign"
                    style={{float:'right'}}
                    onClick={()=>{props.setLeftPage('home')}}
                  >
                    <ChevronLeftIcon/>
                  </IconButton>
                  }
                </div>
            </Box>
            {searchBox()}
            <Divider />
            {pageData&&
            <Box>
              {/* ponytail: narrow left panel — give Other Details ~half width; stack date/time; wrap action */}
              <Table
                className="color-table"
                aria-label="simple table"
                sx={{
                  width: '100%',
                  tableLayout: 'fixed',
                  '& .MuiTableCell-root': {
                    padding: '6px 6px',
                  },
                }}
              >
                <colgroup>
                  <col style={{ width: '16%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '12%' }} />
                  <col style={{ width: '37%' }} />
                </colgroup>
                <TableHead>
                  <TableRow>
                    <TableCell
                      align={'left'}
                      sortDirection={orderBy === 'date' ? order : false}
                      style={{textAlign:'left'}}
                    >
                      <TableSortLabel
                        active={orderBy === 'date'}
                        direction={orderBy === 'date' ? order : 'asc'}
                        onClick={()=>createSortHandler('date')}
                      >
                        Date
                        {orderBy === 'date' ? (
                          <Box component="span" sx={visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </Box>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell
                      style={{textAlign:'left'}}
                      align={'left'}
                      sortDirection={orderBy === 'user' ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === 'user'}
                        direction={orderBy === 'user' ? order : 'asc'}
                        onClick={()=>createSortHandler('user')}
                      >
                        User
                        {orderBy === 'user' ? (
                          <Box component="span" sx={visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </Box>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell style={{textAlign:'left'}} align={'left'}>
                      Action
                    </TableCell>
                    <TableCell style={{textAlign:'left'}} align={'left'}>
                      Booth #
                    </TableCell>
                    <TableCell style={{textAlign:'left'}} align={'left'}>
                      Other Details
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pageData.map((booth, index) => {
                    var display = getAuditDisplayRow(booth);
                    var dateParts = formatAuditDateParts(booth.date);
                    return (
                    <TableRow
                      key={index}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell size="small" style={{textAlign:'left', fontSize:12, verticalAlign:'top', lineHeight:1.35}}>
                        {dateParts.dateLine ? (
                          <>
                            <div>{dateParts.dateLine}</div>
                            {dateParts.timeLine ? <div>{dateParts.timeLine}</div> : null}
                          </>
                        ) : null}
                      </TableCell>
                      <TableCell size="small" style={{textAlign:'left', fontSize:12, verticalAlign:'top', wordBreak:'normal', overflowWrap:'break-word', lineHeight:1.35}}>
                        {booth.user || ''}
                      </TableCell>
                      <TableCell size="small" style={{textAlign:'left', fontSize:12, verticalAlign:'top', whiteSpace:'normal', wordBreak:'normal', overflowWrap:'break-word', lineHeight:1.35}}>
                        {display.actionLabel}
                      </TableCell>
                      <TableCell size="small" style={{textAlign:'left', fontSize:12, verticalAlign:'top', wordBreak:'break-all', lineHeight:1.35}}>
                        {display.boothNumber}
                      </TableCell>
                      <TableCell
                        size="small"
                        style={{textAlign:'left', fontSize:12, verticalAlign:'top', whiteSpace:'pre-line', wordBreak:'normal', overflowWrap:'break-word', lineHeight:1.35}}
                      >
                        {display.otherDetails === '-' ? '-' : renderDescription(booth.description)}
                      </TableCell>
                    </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
            }
            <Box mt={2} mb={0}>
              <Stack spacing={2}>
                <Pagination variant="outlined" shape="rounded" style={{justifyContent:'center'}} count={Math.ceil(filteredBoothList.length/page_size)} color="primary"  page={page} onChange={handleChangePage}/>
              </Stack>
            </Box>
            
            <LoadingOverlay
                active={loadingFlag}
                styles={{
                    // spinner: (base) => ({
                    // ...base,
                    // width: '50px',
                    // '& svg circle': {
                    //     stroke: '#1976d2'
                    // }
                    // }),
                    overlay: (base) => ({
                    ...base,
                    fontSize:'18px',
                    color: 'rgb(5, 37, 51)',
                    // background: 'rgb(229 229 229 / 92%)',
                    background: 'transparent',
                    position:'absolute',
                    left:'50%',
                    top:'200px',
                    transform:'translateX(-50%)',
                    zIndex:1000000000
                    })
                }}
                spinner = {<ScaleLoader color={props.ui?.customStyles?.['spinner-color']?props.ui?.customStyles['spinner-color']:'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
                // spinner
                // text='Loading ...'
                >
            </LoadingOverlay> 
        </Box>
      </div>
    </Fade>
  );
}

const mapStateToProps = (state) => {
  return {
    main: state.main,
    ui: state.ui,
    log: state.log,
    booth_history: state.booth_history.present
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setLeftPage: value=>dispatch(setLeftPage(value)) ,
    setLeftSearchVal: value=>dispatch(setLeftSearchVal(value)) ,
    setOpenBoothList: value=>dispatch(setOpenBoothList(value)) ,
    setActive3dObject: value=>dispatch(setActive3dObject(value)) ,
  };
};

export default connect(mapStateToProps, mapDispatchProps)(BoothList);
